(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.th = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      datepicker: {
        apply: 'Apply',
        // to be translated
        clearSelection: 'Clear selection',
        // to be translated
        pickADays: 'Select days',
        // to be translated
        now: 'ตอนนี้',
        today: 'วันนี้',
        cancel: 'ยกเลิก',
        clear: 'ล้างข้อมูล',
        confirm: 'ตกลง',
        selectDate: 'เลือกวันที่',
        selectTime: 'เลือกเวลา',
        startDate: 'วันที่เริ่มต้น',
        startTime: 'เวลาเริ่มต้น',
        endDate: 'วันที่สิ้นสุด',
        endTime: 'เวลาสิ้นสุด',
        prevYear: 'Previous Year',
        // to be translated
        nextYear: 'Next Year',
        // to be translated
        prevMonth: 'Previous Month',
        // to be translated
        nextMonth: 'Next Month',
        // to be translated
        year: 'ปี',
        month1: 'มกราคม',
        month2: 'กุมภาพันธ์',
        month3: 'มีนาคม',
        month4: 'เมษายน',
        month5: 'พฤษภาคม',
        month6: 'มิถุนายน',
        month7: 'กรกฎาคม',
        month8: 'สิงหาคม',
        month9: 'กันยายน',
        month10: 'ตุลาคม',
        month11: 'พฤศจิกายน',
        month12: 'ธันวาคม',
        weeks: {
          sun: 'อา',
          mon: 'จ',
          tue: 'อ',
          wed: 'พ',
          thu: 'พฤ',
          fri: 'ศ',
          sat: 'ส'
        },
        months: {
          jan: 'มกรา',
          feb: 'กุมภา',
          mar: 'มีนา',
          apr: 'เมษา',
          may: 'พฤษภา',
          jun: 'มิถุนา',
          jul: 'กรกฎา',
          aug: 'สิงหา',
          sep: 'กันยา',
          oct: 'ตุลา',
          nov: 'พฤศจิกา',
          dec: 'ธันวา'
        },
        pickADay: 'Select a day'
      },
      select: {
        loading: 'กำลังโหลด',
        noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
        noData: 'ไม่พบข้อมูล',
        placeholder: 'เลือก'
      },
      pagination: {
        goto: 'ไปที่',
        pagesize: '/หน้า',
        total: 'ทั้งหมด {total}',
        pageClassifier: ''
      },
      upload: {
        deleteTip: 'press delete to remove',
        // to be translated
        delete: 'ลบ',
        preview: 'ตัวอย่าง',
        continue: 'ทำต่อ'
      },
      table: {
        emptyText: 'ไม่พบข้อมูล',
        confirmFilter: 'ยืนยัน',
        resetFilter: 'รีเซ็ต',
        clearFilter: 'ทั้งหมด',
        sumText: 'Sum' // to be translated

      },
      tree: {
        emptyText: 'ไม่พบข้อมูล'
      }
    }
  };
  _exports.default = _default;
});